import { render, staticRenderFns } from "./CargaTabs.vue?vue&type=template&id=1b78c1ca&"
import script from "./CargaTabs.vue?vue&type=script&lang=js&"
export * from "./CargaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports